<template>
    <div class="m-5">
        <h1 class="text-5xl text-slate-600 font-bold tracking-tight">Colors</h1>

        <div class="flex flex-col items-center w-32">
            <div>Primary Color</div>
            <div class="w-16 h-16 rounded-full bg-pink-500 m-2"></div>
            <input type="text" class="block w-full rounded-md border-gray-300">
        </div>

    </div>
</template>

<script>
export default {
    name: 'ColorEditor',
    props: ['prop1', 'prop2'],
    data () {
        return {
            model: webase.model,
            styleGuide: {
                primaryColor: '',
                secondaryColor: '',
                tertiaryColor: '',
            }
        }
    },
    mounted () {
    },
    methods: {
        importantMethodHere () {
        }
    }
}
</script>
